import { ordersApi } from 'store/orders/ordersApi';

import { CreateOrderNoteBody, OrderNoteProps, UpdateOrderNoteBody } from './orderNotes.types';

export const orderNotesApiSlice = ordersApi.injectEndpoints({
  endpoints: (build) => ({
    createOrderNote: build.mutation<OrderNoteProps, { body: CreateOrderNoteBody; orderId: string }>(
      {
        query: ({ body, orderId }) => ({
          body,
          method: 'POST',
          url: `${import.meta.env.VITE_API_URL}/planex/proxy/v2/orders/${orderId}/notes`
        }),
        transformResponse: (response: { data: OrderNoteProps }) => response.data
      }
    ),
    getOrderNotes: build.query<
      OrderNoteProps[],
      { limit: number; orderId: string; pageNo: number }
    >({
      query: ({ limit, orderId, pageNo }) =>
        `/v2/orders/${orderId}/notes?limit=${limit}&pageNo=${pageNo}`,
      transformResponse: (response: { data: OrderNoteProps[]; success: boolean }) => response.data
    }),
    updateOrderNote: build.mutation<
      OrderNoteProps,
      { body: UpdateOrderNoteBody; noteId: string; orderId: string }
    >({
      query: ({ body, noteId, orderId }) => ({
        body,
        method: 'PUT',
        url: `${import.meta.env.VITE_API_URL}/planex/proxy/v2/orders/${orderId}/notes/${noteId}`
      }),
      transformResponse: (response: { data: OrderNoteProps }) => response.data
    })
  })
});

export const { useCreateOrderNoteMutation, useLazyGetOrderNotesQuery, useUpdateOrderNoteMutation } =
  orderNotesApiSlice;
